export const DEFAULT_GUIDELINE_URL =
  "https://stage-leads-data.blr1.cdn.digitaloceanspaces.com/guideline-documents-mso/july-2024-important-guideline.pdf";
export const CHIKITSA_SATHI_GUIDELINE_URL =
  " https://stage-leads-data.blr1.cdn.digitaloceanspaces.com/guideline-documents-mso/july-2024-chikitsa-sathi-important-guideline.pdf";
